import { Injectable } from "@angular/core";
import { Product } from "src/app/api/models";
import { ClientService } from "src/app/api/services";

declare var toastr: any;

@Injectable()
export class ProductService {
  constructor(
    private clientService: ClientService,
  ) { }

  /*
   ----------  Cart Product Function  ----------
  */

  // Adding new Product to cart db if logged in else localStorage
  addToCart(data: Product): void {
    const a: Product[] = JSON.parse(localStorage.getItem("avct_item")) || [];
    const quantity = JSON.parse(localStorage.getItem("dict_item")) || {};

    this.clientService.getProduct({ product_id: data.product_id }).subscribe(
      (product) => {

        let availableQuantity = product.quantity ? product.quantity : 1;

        if (data.product_id in quantity) {
          quantity[data.product_id] = quantity[data.product_id] + 1;
        }
        else {
          a.push(data);
          quantity[data.product_id] = 1;
        }

        quantity[data.product_id] = Math.min(quantity[data.product_id], availableQuantity);

        toastr.success('Aggiunto al carrello', data.description.toLocaleUpperCase(), {
          timeOut: 1500,
          "positionClass": "toast-top-right"
        })
        setTimeout(() => {
          localStorage.setItem("avct_item", JSON.stringify(a));
          localStorage.setItem("dict_item", JSON.stringify(quantity));
        }, 500);

      }
    )
  }

  // Removing cart from local
  removeLocalCartProduct(product: Product) {
    const products: Product[] = JSON.parse(localStorage.getItem("avct_item"));
    const quantity = JSON.parse(localStorage.getItem("dict_item")) || {};

    for (let i = 0; i < products.length; i++) {
      if (products[i].product_id === product.product_id) {
        products.splice(i, 1);
        break;
      }
    }
    if (product.product_id in quantity) {
      delete quantity[product.product_id];
    }
    // ReAdding the products after remove
    localStorage.setItem("avct_item", JSON.stringify(products));
    localStorage.setItem("dict_item", JSON.stringify(quantity));
  }

  emptyCart() {
    localStorage.removeItem("avct_item");
    localStorage.removeItem("dict_item");
  }

  // Fetching Locat CartsProducts
  getLocalCartProducts(): Product[] {
    const products: Product[] =
      JSON.parse(localStorage.getItem("avct_item")) || [];

    return products;
  }

  getProductQuantity(product_id: number): number {
    const quantity = JSON.parse(localStorage.getItem("dict_item")) || {};
    if (product_id in quantity) {
      return quantity[product_id];
    } else {
      return 0;
    }
  }

  increaseProductQuantity(product_id: number): void {
    const quantity = JSON.parse(localStorage.getItem("dict_item")) || {};

    this.clientService.getProduct({ product_id: product_id }).subscribe(
      (product) => {
        let availableQuantity  = product.quantity ? product.quantity : 1;

        if (product_id in quantity) {
          quantity[product_id] = quantity[product_id] + 1;
        } else {
          quantity[product_id] = 1;
        }
        if (quantity[product_id] > availableQuantity) {
          let disp = 'disponibili'
          if (availableQuantity == 1){
            disp = 'disponibile'
          }
          toastr.info('Solo ' + availableQuantity + ' pezzi ' + disp + ' per questo prodotto', 'Massima Disponibilità Raggiunta', {
            timeOut: 1500,
            "positionClass": "toast-top-right"
          })
        }

        quantity[product_id] = Math.min(quantity[product_id], availableQuantity);

        localStorage.setItem("dict_item", JSON.stringify(quantity));
      })
  }

  decreaseProductQuantity(product_id: number): void {
    const quantity = JSON.parse(localStorage.getItem("dict_item")) || {};
    if (product_id in quantity) {
      quantity[product_id] = quantity[product_id] - 1;
    } else {
      quantity[product_id] = 0;
    }
    quantity[product_id] = Math.max(0, quantity[product_id]);
    localStorage.setItem("dict_item", JSON.stringify(quantity));
  }
}